import { toast } from "react-toastify";
function successToast(message,duration = 3000) {
  console.log(message);
  toast(message, {
    type: "success",
    position: "top-right",
    autoClose: duration
  })
}
function errorToast(message,duration = 3000) {
  console.log(message);
  toast(message, {
    type: "error",
    position: "top-right",
    autoClose: duration
  })
}
export function copyToClipboard(str){
  const el = document.createElement("textarea");
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
  successToast("Copied",1000);
}

export {
  successToast, errorToast
}